import { ChangeDetectionStrategy, Component } from '@angular/core';
import { EnvironmentService } from '@libs/order-process/shared/core';
import { ApiUrlService, StorageService, VaultService } from '@libs/shared/core';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';

import { environment } from '../environments/environment';
import { version } from '../environments/version';

@Component({
  selector: 'mf-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  constructor(
    private readonly apiUrlService: ApiUrlService,
    private readonly environment: EnvironmentService,
    private readonly storage: StorageService,
    private readonly translate: TranslateService,
    private readonly vaultService: VaultService,
  ) {
    this.initializeApp();
  }

  public async initializeApp(): Promise<void> {
    this.environment.init(environment, version);
    this.apiUrlService.init(this.environment.apiUrl);
    this.storage.init(this.environment.storagePrefix);
    this.translate.setFallbackLang(this.environment.defaultLanguage);
    await lastValueFrom(this.translate.use(this.environment.defaultLanguage));

    await this.vaultService.init();
  }
}
